/**
 * Buildings/Index mount point.
 *
 * Thin flag-aware wrapper consumed by the Rails ERB mounts:
 *   - `app/views/buildings/_kendo_index.html.erb` (standalone)
 *   - `app/views/accounts/menu/_buildings_tab_react.html.erb` (account embed)
 *
 * Flag-aware: when modernizedBuildingsListingsEnabled is false (default), renders
 * the legacy Kendo-based listing. When true, renders the modern React Query listing.
 * The flag prop is stripped before forwarding so neither branch receives it.
 *
 * Static imports — no code-splitting — so the OFF path has no extra loading state.
 * The QueryClient is module-level for cache stability across re-renders.
 *
 * IP-15372: independent of modernizedInspectionListingsEnabled. Flipping one must
 * never affect the other.
 */

/* eslint-disable react/prop-types */
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BuildingsListing } from './BuildingsListing';
import LegacyBuildingsIndex from './legacy/LegacyBuildingsIndex';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

export default function BuildingsIndex({ modernizedBuildingsListingsEnabled = false, ...props }) {
  if (!modernizedBuildingsListingsEnabled) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <LegacyBuildingsIndex {...props} />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <BuildingsListing {...props} />
    </QueryClientProvider>
  );
}
